import Ember from 'ember';
import version from './version';
const overridesConfig = {
  enabled: false,
  envOverrides: {}
};
export function setEnvironmentOverrides(newOverrides) {
  overridesConfig.enabled = true;
  overridesConfig.envOverrides = newOverrides;
}
export function clearEnvironmentOverrides() {
  overridesConfig.enabled = false;
}
const envOverridesDefaults = {
  isMobile: false,
  isAndroid: false,
  isIOS: false,
  isDevelopment: false,
  isTesting: false,
  isStaging: false,
  isSandbox: false,
  isProduction: false,
  isHeadless: false,
  name: '',
  version: 'test-version'
};

/**
 * Returns a plain object describing the current environment.
 *
 * @param  {Object} [opts={}] Object containing overrides for information that
 *   is derived from the global environment.
 * @return {Object} Environment object
 */
export default function environment(opts = {}) {
  if (overridesConfig.enabled) {
    return {
      ...envOverridesDefaults,
      ...overridesConfig.envOverrides
    };
  }
  const _window = opts.window || window;
  const _ember = opts.Ember || Ember;
  const _userAgent = opts.userAgent || navigator.userAgent;
  const isMobile = isUserAgentMobile(_userAgent);
  const isAndroid = isUserAgentAndroid(_userAgent);
  const isIOS = isUserAgentIOS(_userAgent);
  const isDevelopment = isDevelopmentHost(_window.location.hostname);
  const isStaging = isStagingHost(_window.location.hostname);
  const isTesting = isTestEnvironment(_ember, _window);
  const isSandbox = isSandboxHost(_window.location.hostname);
  const isHeadless = isHeadlessEnviroment(_userAgent);
  const isProduction = !isDevelopment && !isSandbox && !isStaging && !isTesting;
  return {
    isMobile,
    isAndroid,
    isIOS,
    isDevelopment,
    isTesting,
    isStaging,
    isSandbox,
    isProduction,
    isHeadless,
    name: getEnvironmentName(isDevelopment, isTesting, isStaging, isSandbox),
    version
  };
}
/**
 * Returns a name for the current environment.
 *
 * @param  {Boolean} isDevelopment
 * @param  {Boolean} isTesting
 * @param  {Boolean} isStaging
 * @param  {Boolean} isSandbox
 * @return {EnvironmentName} Name of the environment
 */
function getEnvironmentName(isDevelopment, isTesting, isStaging, isSandbox) {
  if (isTesting) {
    return 'testing';
  } else if (isDevelopment) {
    return 'development';
  } else if (isStaging) {
    return 'staging';
  } else if (isSandbox) {
    return 'sandbox';
  } else {
    return 'production';
  }
}
function isUserAgentMobile(userAgent) {
  // using mobi instead of mobile since mobi is in the Opera UA strings, not mobile
  // as of 02/12/14 (b)
  return /mobi|android|iphone/i.test(userAgent) && !/ipad/i.test(userAgent);
}
function isUserAgentAndroid(userAgent) {
  return /android/i.test(userAgent);
}
function isUserAgentIOS(userAgent) {
  return /ipad|iphone/i.test(userAgent);
}
function isDevelopmentHost(hostname) {
  return hostname === 'localhost' || /squareup\.com\.[,A-Za-z-]*\.local$/.test(hostname);
}
function isSandboxHost(hostname) {
  return /^(app\.)?squareupsandbox\.com$/.test(hostname);
}
function isStagingHost(hostname) {
  return /^broadway\.squareup\.com$|^(?:[\w-]+\.)*squareupstaging\.com$|^[\w-]+\.stage\.sqprod\.co$/.test(hostname);
}
function isTestEnvironment(emberGlobal, windowObject) {
  return emberGlobal.testing === true || windowObject.runningTests === true;
}
function isHeadlessEnviroment(userAgent) {
  return /headlesschrome/i.test(userAgent);
}